import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";

interface BIconProps {
  icon: string;
  width?: number;
  heigth?: number;
  className?: string;
}

export const BIcon: React.FC<BIconProps> = ({ icon, width, heigth, className }: BIconProps) => {
  return (
    <>
      <i className={`bi bi-${icon} nav-icon ${className}`} style={{ marginTop: "-10px"}}></i>
    </>
  );
};
